export const setupAtPolyfill = () => {
  if (!Array.prototype.at) {
    Array.prototype.at = function (index: number) {
      return atPolyfill(this, index)
    }
  }
}

export const atPolyfill = (array: any[], index: number) => {
  if (array.length >= index && index >= 0) {
    return array[index]
  } else if (index < 0 && array.length >= Math.abs(index) - 1) {
    const positiveIndex = Math.abs(index) - 1
    return array.reverse()[positiveIndex]
  } else {
    return undefined
  }
}
